// extracted by mini-css-extract-plugin
export default {"container":"CarrusellArrowRight_container__UVhfU"};